// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__23UZO","footer":"ModalError_footer__1ZnDW"};